export default __webpack_public_path__ + "static/policies-6267462e7707c762b8e6636f4a7f566a.png";